import { memo } from 'react';
import DotTemplate from './DotTemplate.js';
import { useSliderValue } from './SliderContext.js';
import { jsx } from 'react/jsx-runtime';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/objectSpread2';
import '@dtvgo/slider-dot';
import '@dtvgo/utils';
import './utils.js';
import '@dtvgo/classnames';

/* External */
function Dot(_ref) {
  var className = _ref.className,
    style = _ref.style,
    children = _ref.children;
  var value = useSliderValue();
  return /*#__PURE__*/jsx(DotTemplate, {
    className: className,
    style: style,
    value: value,
    children: children
  });
}
Dot.defaultProps = {
  className: '',
  style: {},
  children: null
};
var Dot$1 = /*#__PURE__*/memo(Dot);

export { Dot$1 as default };
//# sourceMappingURL=Dot.js.map
